export const gbConstants = {
    HOST_SERVICE: "https://adzrunner.com/api/customer",
    
    PATH_ROOT: "/",
    PATH_JOURNEY: "/journey",
    PATH_LOGIN: "/login",
    PATH_VERIFY_ACCOUNT: "/verify-account",
    PATH_CREATE_CAMPAIGN: "/create-campaign",
    PATH_CAMPAIGN_DETAIL: "/campaign-detail",
    PATH_CHART_DETAIL: "/chart-detail",
    PATH_PROFILE: "/profile"
};

export const THEME = {
    COLOR: {
        MAIN: "#252e3b",
        GREEN: "#429988",
        GREEN_HOVER: "#5baf9f",
        BLUE: "#1c99e1",
        BLUE_HOVER: "#3eaff0",
        YELLOW: "#f3af07",
        YELLOW_HOVER: "#f6bd31",
        GRAY_CAMPAIGN_STATUS: "#656f85",
        GRAY: "#ebebeb",
        GRAY_EXPAND_ICON: "#c1bebe",
        WHITE_HOVER: "#f0f0f0"
    },
    BORDER: {
        WIDTH: 1,
        RADIUS: 3
    }
};

export const DATE_FORMAT = "DD/MM/YYYY";

// HOST_SERVICE: "http://localhost:9901/customer",


// WEBPACK FOOTER //
// ./src/_constants/constants.js